var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},[_c('v-icon',{attrs:{"color":_vm.color,"small":""}},[_vm._v("mdi-square")]),_c('span',{staticClass:"legend-label",style:({color: _vm.color})},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }